import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;

export const loadPublicSettings = (force = false) => {
  if (!cache || force) cache = api.get("/settings/public").then((r) => r.data).catch(() => ({ figures: null, contact: null }));
  return cache;
};

export const usePublicSettings = () => {
  const [data, setData] = useState(null);
  useEffect(() => { loadPublicSettings().then(setData); }, []);
  return data;
};

export const telHref = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;

export const fmtIntl = (phone) => {
  const d = phone.replace(/\D/g, "");
  if (d.startsWith("33") && d.length === 11) return `+33 ${d[2]} ${d.slice(3).match(/../g).join(" ")}`;
  return `+${d}`;
};

export const waHref = (phone, text) => `https://wa.me/${phone.replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;
